import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import State from '@wfp-root-app/store/state';

import { ActivityLogsList } from '../activityLogs/ActivityLogsList';
import { ActionCreators as ManagerActionCreators } from '../managers/managers';
import { ManagerPermission } from '../permission-profiles/permission';
import { ActionCreators as PartnerActionCreators } from '../partners/partnersActions';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function mapDispatchToProps(dispatch: any) {
    return {
        loadActivityLogs: (page, limit, managerId) =>
            dispatch(ManagerActionCreators.loadActivityLogs(managerId, page, limit)),
        loadManagersNickNames: bindActionCreators(ManagerActionCreators.loadManagersNickNames, dispatch),
        loadPartnersNames: bindActionCreators(PartnerActionCreators.loadPartnersNames, dispatch),
        loadPartnerUserNames: bindActionCreators(PartnerActionCreators.loadPartnerUsersName, dispatch),
        isManager: true,
    };
}

function mapStateToProps(state: State) {
    return {
        activityLogs: state.managers.activityLogs,
        managersNickNames: state.managers.managerNickNameList,
        partnersNickNames: state.partners.nameList,
        partnerUsersNickNames: state.partners.partnerUsersNamesList,
        auth: state.auth,
        entityId: state.auth.manager?.id ?? '',
        url: state.auth.manager ? `/admin/${state.auth.manager.id}/activity/export-activity-log` : `/login`,
        downloadRestriction: [ManagerPermission.userActivityDownload],
    };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default connect(mapStateToProps, mapDispatchToProps, null)(ActivityLogsList) as any;
